import React from 'react';
import { Chip, ChipProps } from '@mui/material';

type StatusType = 'active' | 'inactive' | 'pending' | 'completed' | 'cancelled' | 'admin' | 'user';

interface StatusBadgeProps {
  status: string;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

/**
 * A reusable component for displaying status badges
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ 
  status, 
  size = 'small',
  variant = 'filled'
}) => {
  // Normalize the status to lowercase for consistent mapping
  const normalizedStatus = status.toLowerCase() as StatusType;
  
  // Define color mapping for different status types
  const getStatusColor = (status: StatusType): ChipProps['color'] => {
    switch (status) {
      case 'active':
        return 'success';
      case 'inactive':
        return 'error';
      case 'pending':
        return 'warning';
      case 'completed':
        return 'success';
      case 'cancelled':
        return 'error';
      case 'admin':
        return 'primary';
      case 'user':
        return 'default';
      default:
        return 'default';
    }
  };

  // Get display label with proper capitalization
  const getDisplayLabel = (status: string): string => {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  return (
    <Chip 
      label={getDisplayLabel(status)}
      color={getStatusColor(normalizedStatus)}
      size={size}
      variant={variant}
    />
  );
};

export default StatusBadge;
